import * as React from 'react'
import type { SVGProps } from 'react'
function IconBarrierefreiheit(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      color="currentColor"
      viewBox="0 0 415.8 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M196.4,1.2c-15.4,2.9-31.4,15.4-38.6,30.4-10.6,21.8-6.4,46.6,10.7,63.8,27.2,27.1,72.8,19.5,89.5-15,20.2-41.7-15.7-87.9-61.6-79.2Z" />
      <path d="M16.1,114.6C6.1,119.6-1,133.9.1,146.8c.7,7.3,2.7,11.2,8.5,16.9,7.7,7.5,18.9,11.9,70.3,27.8,26.1,8.1,49.5,15.8,52,17,5.5,2.8,7.8,5.2,9.6,10.2,4.2,12-1.3,53.9-23.1,173.5-9.1,49.9-16.5,91.6-16.5,92.6,0,5,3.4,12.7,7.6,17.2,6.6,7.1,12.7,9.4,24.4,9.5,8.4,0,10.1-.3,14.6-2.7,5.8-3,9.4-6.9,12.9-13.8,3-5.8,4.5-12.1,8.5-33.5,8.1-44,20-95.4,27.1-117,5.7-17.6,9.7-23.6,13.4-20.5,7.6,6.3,20.4,53.1,36.5,133.5,6.8,34.4,8.4,39,15.5,46.2,6.7,6.6,13.4,8.8,24.1,8,16.7-1.3,28.5-12.1,28.7-26.5,0-3.4-6.7-41.7-16.6-94.7-15.6-83.4-22.4-125.6-24.3-151-.7-9.6.8-19,3.7-22.1,4-4.3,12.6-7.8,62.1-25,27.7-9.7,53.4-19.2,57.2-21.2,9.2-4.8,15.9-11.6,18.1-18.3,3.7-10.9-.5-25.9-9.5-34.3-8-7.5-13.6-8-30.6-3.1-25.9,7.6-68.9,17.4-94.9,21.9-54.5,9.2-84.4,9.6-135,1.5-29.4-4.7-80.3-16.3-104.9-23.9-12.1-3.7-16.6-3.8-23.4-.4Z" />
    </svg>
  )
}
export default IconBarrierefreiheit
